export enum citizenship {
  NATIONAL = 'NATIONAL',

  FOREIGN = 'FOREIGN',
}
